import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class DirectionService {

     constructor(){
        this.adresse = new AdresseIP()
    }
        
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/direction')
                    .then(res => res.data);
    }
    create(newDirection) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/direction'
        return axios.post(url,newDirection)
                    .then(res => res.data);
    }
    update(idDirection ,newDirection) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/direction/'
        return axios.put(url+idDirection, newDirection)
                    .then(res => res.data);
    }
    delete(idDirection) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/direction/'
        return axios.patch(url+idDirection)
                    .then(res => res.data)
    }
    get(idDirection) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/direction/'
        return axios.patch(url+idDirection)
                    .then(res => res.data)
    }

}